const styles = {
    '@global': {
        'html, body, #root': {
            height: '100%',
            width: '100%',
            padding: 0,
            overflow: 'hidden',
            margin: 0
        },
        a: {
            textDecoration: 'none'
        }
    }
};

export default styles;
